import React from "react";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import TicketInformationMD from "./TicketInformationMD";
import TicketInformation_new from "./TicketInformation_new";

const TicketInformation = (props) => {
  const { state: profileState } = useSelector((state) => ({
    state: state.profile,
  }));

  return (
    <>
      <ToastContainer rtl={true}/>
      {/* <div >
        <TicketInformationMD data={profileState.userHistory} />
      </div> */}
      <div >
        <TicketInformation_new data={profileState.userHistory} />
      </div>
    </>
  );
};

export default TicketInformation;
